module.exports = __webpack_public_path__ + "img/door-open.70be87ed.jpg";